module.exports = __webpack_public_path__ + "static/media/PreguntasFrecuentes.6c53cab9.jpg";